module.exports = __webpack_public_path__ + "static/media/pdf_placeholder.5c7d818b.svg";